import React from 'react'
import toLower from 'lodash/toLower'
import { BusyButton } from '@ztechapps/webui.button'
import type { UseMutationProps } from '@ztechapps/common.hook'
import { useConfirmDialog, useError, useMutation } from '@ztechapps/common.hook'
import type { User } from '@ztechapps/common.contract'
import { UserStatusEnum } from '@ztechapps/common.contract'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

const documentFragment = `_id
    tenantId
    status
    type
    profile {
      name
      picture
      email
      _id
    }
  `
const userQueries = buildGraphqlQuery('User', documentFragment)
type ToggleActivationButtonProps = { user: User; disabled?: boolean; title?: string; mutationConfig?: UseMutationProps }

export const ToggleActivationButton = ({ user, disabled, title, mutationConfig }: ToggleActivationButtonProps) => {
  if (!mutationConfig) {
    mutationConfig = {
      ...userQueries.updateConfig,
      options: { mutationOptions: { refetchQueries: ['allUser'] } },
    }
  }

  const { _id, profile, status } = user ?? {}
  const statusTitle = `${status === UserStatusEnum.active ? 'De-a' : 'A'}ctivate`
  const [activateNow, , { loading, error }] = useMutation(mutationConfig)
  useError(error)
  const { confirm } = useConfirmDialog({
    text: `Are you sure you to ${toLower(statusTitle)} '${profile?.name}'?`,
    title: `${statusTitle}?`,
    buttons: { confirm: { text: `Yes, ${toLower(statusTitle)} it!` } },
  })

  const onClick = async () => {
    const newStatus = status === UserStatusEnum.active ? UserStatusEnum.inActive : UserStatusEnum.active
    await confirm(() => activateNow({ input: { _id, status: newStatus } }))
  }

  let icon = 'rectangle-xmark'
  if (status === UserStatusEnum.inActive) {
    icon = 'check-square'
  }

  return (
    <BusyButton
      icon={icon}
      isBusy={loading}
      disabled={disabled}
      text={statusTitle}
      title={title ?? `${statusTitle} the selected user`}
      busyText="Updating..."
      onClick={onClick}
    />
  )
}
